import { EMPTY_OBJECT } from '../../constants/common'
import { getApi } from '../../utils/api'

import { CHAT_PARTICIPANTS_OPTIONS_API_PARAMS } from './User.constants'

export function searchUsers({
  apiConfig = EMPTY_OBJECT,
  archived = false,
  search,
}) {
  return getApi({
    ...apiConfig,
    endpoint: `/api/profile/live-search/dweller/`,
    params: { ...apiConfig.params, archived, query: search },
  })
}

export function getAvailableChatParticipants({ search, ...restParams }) {
  const params = {
    ...restParams,
    ...(search ? { fullname: search } : {}), // to get filtered participants we need fullname param
    ...CHAT_PARTICIPANTS_OPTIONS_API_PARAMS,
  }

  return getApi({
    endpoint: `/api/profile/available-chat-members/`,
    params,
  })
}

export function getUserInfoStatuses(params) {
  return getApi({
    endpoint: 'api/user-info-status/',
    params,
  })
}

export function getProfileUserTooltip(userId, apiConfig = EMPTY_OBJECT) {
  return getApi({
    ...apiConfig,
    endpoint: `idwell-api/api/v3/profile/${userId}/tooltip/`,
  })
}
